import { gql } from "gql";

export const UNCOMPLETED_TASKS_NUMBER_SUBSCRIPTION = gql(/* GraphQL */ `
  subscription UncompletedTasksNumberSubscription {
    personTasksUncompletedCountSubscription
  }
`);
